import React, { useState, useEffect } from "react";
import { SENSAIPanel } from "./SENSAIPanel";

interface SENSAILauncherProps {
  variant?: 'fixed' | 'header';
}

export const SENSAILauncher: React.FC<SENSAILauncherProps> = ({ variant = 'fixed' }) => {
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState<"teach" | "verify" | "chat">("teach");

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "?" && !e.ctrlKey && !e.metaKey && !e.altKey) {
        e.preventDefault();
        setMode("teach");
        setOpen(true);
      } else if (e.key === "v" && !e.ctrlKey && !e.metaKey && !e.altKey) {
        e.preventDefault();
        setMode("verify");
        setOpen(true);
      } else if (e.key === "c" && !e.ctrlKey && !e.metaKey && !e.altKey) {
        e.preventDefault();
        setMode("chat");
        setOpen(true);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const buttonClasses = variant === 'header' 
    ? "sensai-launcher text-white flex items-center gap-2 px-3 py-2 rounded-lg bg-purple-600 hover:bg-purple-700 transition-colors duration-200 text-sm font-medium"
    : "sensai-launcher fixed bottom-6 left-6 text-white z-50 flex items-center gap-3 px-5 py-3 rounded-full group";

  return (
    <>
      <button
        aria-label="Ask SENSAI"
        onClick={() => {
          setMode("chat");
          setOpen(true);
        }}
        className={buttonClasses}
        style={variant === 'fixed' ? { zIndex: 9999 } : undefined}
      >
        <div className="text-xl group-hover:scale-110 transition-transform duration-200">
          🤖
        </div>
        <span className="text-sm font-semibold tracking-wide">Ask SENSAI</span>
        <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
      </button>
      {open && (
        <SENSAIPanel
          onClose={() => setOpen(false)} 
          initialTab={mode}
        />
      )}
    </>
  );
};
